<template>
  <div class="mb-[2rem]">
    <section class="h-full w-full">
      <div class="w-full max-w-7xl 2xl:max-w-screen-2xl mx-auto">
        <div class="py-4 ">
          <div class="flex justify-between px-5 2xl:px-[8.9rem]">
            <div>
              <h2
                class="text-black text-3xl text-left md:text-left font-extrabold"
              >
                Blogs 
              </h2>
              <p
                class="w-[15rem] md:w-[45rem] m-auto font-medium md:text-base text-[14px] text-black text-left md:text-left"
              >
                Our take on academics and everything beyond.
              </p>
            </div>
            <a href="/blogs">
              <button
                class="text-[16px] text-[#001C54] font-bold underline decoration-2 decoration-[#F8C300] underline-offset-4"
              >
                See All
              </button>
            </a>
          </div>
        </div>
        <div class="py-4">
          <div
            class="flex flex-col gap-8 justify-between p-5 2xl:px-[8.9rem]"
          >
            <!-- <div v-if="blogs.length > 0" class="w-full flex flex-col gap-5">
              <div
                v-for="(blog, index) in blogs.slice(0, 1)"
                :key="index"
                class="relative"
              >
                <a :href="`blogs/${blog.slug}`">
                  <img
                    :src="blog.image"
                    :alt="blog.title"
                    class="rounded-3xl md:w-[650px] md:h-[450px] h-[320px] tracking-wide"
                  />

                  <div
                    class="text-justify flex flex-col gap-2 w-full absolute bottom-0 left-0 bg-black p-4 rounded-b-3xl bg-opacity-70"
                  >
                    <h2
                      class="text-white lg:text-[20px] text-[16px] font-bold md:tracking-normal"
                    >
                      {{ blog.title }}
                    </h2>
                    <p class="text-[16px] hidden md:block text-white">
                      {{ blog.description }}
                    </p>
                    <div class="flex gap-5 lg:gap-10 items-center text-white">
                      <p class="text-sm">
                        {{ formatDate(blog.publish_at) }}
                      </p>
                      <ul class="flex">
                        <li class="list-disc">{{ blog.category.title }}</li>
                      </ul>
                    </div>
                  </div>
                </a>
              </div>
            </div> -->
            <div class="flex flex-col lg:flex-row gap-10 w-full">
              <div v-for="(blog, index) in blogs.slice(0, 2)" :key="index">
                <a :href="`blogs/${blog.slug}`">
                  <div class="flex gap-6">
                    <div>
                      <img
                        :src="blog.image"
                        :alt="blog.title"
                        loading="lazy"
                        decoding="async"
                        class="rounded-lg md:w-[205px] md:h-[205px] w-[120px] h-[100px] object-cover"
                      />
                    </div>
                    <div
                      class="text-left flex flex-col gap-2 w-[200px] md:w-[300px]"
                    >
                      <h2
                        class="text-[#1F1F1F] lg:text-[20px] text-[16px] font-bold tracking-tight md:tracking-normal"
                      >
                        {{ blog.title }}
                      </h2>
                      <p class="text-[16px] hidden md:block md:!line-clamp-3">
                        {{ blog.description }}
                      </p>
                      <div class="flex gap-5 lg:gap-7 items-center">
                        <p class="text-xs">
                          {{ formatDate(blog.publish_at) }}
                        </p>
                        <ul class="flex">
                          <li class="list-disc text-xs">
                            {{ blog.category.title }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div class="flex flex-col lg:flex-row gap-10 w-full">
              <div v-for="(blog, index) in blogs.slice(2, 4)" :key="index">
                <a :href="`blogs/${blog.slug}`">
                  <div class="flex gap-6">
                    <div>
                      <img
                        :src="blog.image"
                        :alt="blog.title"
                        loading="lazy"
                        decoding="async"
                        class="rounded-lg md:w-[205px] md:h-[205px] w-[120px] h-[100px] object-cover"
                      />
                    </div>
                    <div
                      class="text-left flex flex-col gap-2 w-[200px] md:w-[300px]"
                    >
                      <h2
                        class="text-[#1F1F1F] lg:text-[20px] text-[16px] font-bold tracking-tight md:tracking-normal"
                      >
                        {{ blog.title }}
                      </h2>
                      <p class="text-[16px] hidden md:block md:!line-clamp-3">
                        {{ blog.description }}
                      </p>
                      <div class="flex gap-5 lg:gap-7 items-center">
                        <p class="text-xs">
                          {{ formatDate(blog.publish_at) }}
                        </p>
                        <ul class="flex">
                          <li class="list-disc text-xs">
                            {{ blog.category.title }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "OurBlogs",

  data() {
    return {
      blogs: [],
    };
  },
  async created() {
      this.fetchBlogPosts();
  },

  methods: {
async fetchBlogPosts() {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API}/blog/blog-list/`
    );
    this.blogs = response.data.data.sort((a, b) => {
      return new Date(b.publish_at) - new Date(a.publish_at);
    });
  } catch (error) {
    console.error("Error fetching blog posts:", error);
  }
},
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { month: "long", day: "2-digit", year: "numeric" };
      return date.toLocaleDateString("en-US", options);
    },
  },
};
</script>

<style></style>
